﻿/**
 * This component interacts with the label for price facets section.
 */
import { store$ } from '@redux/store';
import { distinctUntilChanged, filter, map } from 'rxjs';
import { selectPrice } from '../redux/selectors';
import PriceDualSlider from './priceDualRangeSlider';

export default class PriceFilterLabel {
  constructor(facetPriceLabel) {
    this.priceSlider = document.querySelector('[data-price-slider-container]');
    this.priceMinimumSlider = +this.priceSlider.dataset.min;
    this.priceMaximumSlider = +this.priceSlider.dataset.max;
    this.facetPriceLabel = facetPriceLabel;
    (() => new PriceDualSlider(this.priceSlider))();
    const onPriceChange$ = this.onPriceChange();
    onPriceChange$.subscribe(this.toggleActiveClass.bind(this));
    onPriceChange$.subscribe(this.updatePriceRangeText.bind(this));
  }

  /**
   * gets the label to use for the input depending on the value.
   * returns XXXk if under $999k, returns $X.XM if over $999k
   * @param {int} value
   */
  static getLabel(value) {
    if (value < 999000) {
      return `$${value / 1000}k`;
    }
    return `$${value / 1000000}M`;
  }

  onPriceChange() {
    return store$.pipe(
      filter(selectPrice),
      map(selectPrice),
      distinctUntilChanged(),
      map((value) => ({
        minimum: value.minimumPrice || this.priceMinimumSlider,
        maximum: value.maximumPrice || this.priceMaximumSlider,
      }))
    );
  }

  updatePriceRangeText(price) {
    const { minimum, maximum } = price;
    const priceLabels = {
      minimum: 'No Min',
      maximum: 'No Max',
    };

    if (minimum !== this.priceMinimumSlider) {
      priceLabels.minimum = PriceFilterLabel.getLabel(minimum);
    }

    if (maximum !== this.priceMaximumSlider) {
      priceLabels.maximum = PriceFilterLabel.getLabel(maximum);
    }

    // if both values are the same as the slider's minimum and maximum values, then display 'Price', the default value.
    // otherwise, display the price range.
    if (minimum === this.priceMinimumSlider && maximum === this.priceMaximumSlider) {
      this.facetPriceLabel.textContent = 'Price';
    } else {
      this.facetPriceLabel.textContent = `${priceLabels.minimum} - ${priceLabels.maximum}`;
    }
  }

  /**
   * toggleActiveClass: Adds the active class to the label if the minimumSliderValue and the maximumSliderValue
   * are different than the slider's minimum and maximum values.
   */
  toggleActiveClass(price) {
    const { minimum, maximum } = price;
    if (minimum === this.priceMinimumSlider && maximum === this.priceMaximumSlider) {
        this.facetPriceLabel.classList.remove('nhs-c-select__label--big-text',
                                              'nhs-mq-select__label--big-text-medium',
                                              'nhs-c-select-button--active');
    } else {
      this.facetPriceLabel.classList.add('nhs-c-select__label--big-text', 
                                         'nhs-mq-select__label--big-text-medium', 
                                         'nhs-c-select-button--active');
    }
  }
}
